import { render } from "./PlotAxis.vue?vue&type=template&id=02ffea73"
import script from "./PlotAxis.vue?vue&type=script&lang=js"
export * from "./PlotAxis.vue?vue&type=script&lang=js"

import "./PlotAxis.vue?vue&type=style&index=0&id=02ffea73&lang=scss"

import exportComponent from "/Users/kakkote/Mediadeski/2022-01-aluevaalit-kompassianalyysi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__